export default "__VITE_PUBLIC_ASSET__c97c65fc__"